import React from "react"
import {connect} from "react-redux"

import ToDoList from "./ToDoList"
import {CopyrightFooter} from "./ui/CopyrightFooter"

export class HomePage extends React.Component {

  render() {
    return (
      <React.Fragment>
        <ToDoList/>
        <CopyrightFooter forCosco={this.props?.userProfile?.forCosco}/>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    isAppInitialized: state.app.isAppInitialized,
    userProfile: state.userProfile,
  }
}

export default connect(mapStateToProps)(HomePage)

